import axios from "axios"
import { instanceConfig } from "../config"

export const apiInstance = axios.create(instanceConfig)
